export default "__VITE_ASSET__5a2815ba__"